import React from 'react';
import { Brain, Target, Activity, RefreshCw } from 'lucide-react';
const painPoints = [{
  icon: Brain,
  title: 'Tu mente abandona primero',
  desc: 'Cuando aparece el cansancio empezás a negociar con vos mismo: "bajá el ritmo", "caminá un poco", "ya está bien". Muchas veces abandonás mentalmente antes de llegar a tu verdadero límite físico.'
}, {
  icon: Target,
  title: 'No alcanzás tu mejor marca',
  desc: 'Entrenás duro pero en competencia no lográs mostrar todo tu potencial porque la presión y el diálogo interno juegan en contra.'
}, {
  icon: Activity,
  title: 'Corrés en piloto automático',
  desc: 'Tu cabeza está pensando en el trabajo, los problemas o el reloj. Te cuesta disfrutar el momento y mantener la concentración durante toda la carrera.'
}, {
  icon: RefreshCw,
  title: 'Siempre repetís el mismo patrón',
  desc: 'Entrenás más kilómetros esperando mejorar, cuando muchas veces lo que falta entrenar no son las piernas sino la mente.'
}];
export function PainPoints() {
  return <section id="dolores" className="py-8 px-4 md:px-8 bg-ink text-white" data-id="element-78">
      <div className="max-w-5xl mx-auto" data-id="element-79">
        <div className="text-center mb-6" data-id="element-80">
          <span className="text-sage font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-81">
            Primer Módulo
          </span>
          <h2 className="font-display font-bold text-3xl md:text-5xl mb-6" data-id="element-82">
            ¿Te pasa alguna de estas situaciones?
          </h2>
          <p className="text-lg md:text-xl text-sage-light max-w-3xl mx-auto" data-id="element-83">
            Entrenás varias veces por semana, pero sentís que cuando llega el
            momento difícil de una carrera, es tu cabeza la que te frena antes
            que tus piernas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-84">
          {painPoints.map((point, idx) => <div key={idx} className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors" data-id="element-85">
              <div className="w-12 h-12 bg-forest/30 rounded-xl flex items-center justify-center mb-6" data-id="element-86">
                <point.icon className="w-6 h-6 text-sage" data-id="element-87" />
              </div>
              <h3 className="font-display font-bold text-xl mb-3" data-id="element-88">
                {point.title}
              </h3>
              <p className="text-white/70 leading-relaxed" data-id="element-89">{point.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}